import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProductCustomize = () => {
  const { id } = useParams();
  const [selectedColor, setSelectedColor] = useState('black');
  const [selectedStorage, setSelectedStorage] = useState('1TB');
  const [selectedMemory, setSelectedMemory] = useState('16GB');
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [product, setProduct] = useState(null);
  const [currentImage, setCurrentImage] = useState('');
  
  // 产品数据库
  const productDatabase = {
    'nintendo-joycon-pikachu': {
      name: 'Nintendo Joycon Pikachu',
      description: 'Limited edition gaming controller designed for Nintendo Switch, featuring a vibrant Pikachu-themed design',
      basePrice: 149.99,
      image: 'https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080',
      options: {
        colors: ['pikachu-yellow', 'pikachu-black'],
        addons: [
          { id: 'waist-strips', name: 'Waist Strips', price: 15.99, image: 'https://images.unsplash.com/photo-1600080972464-8e5f35f63d08?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100' },
          { id: 'charger-dock', name: '4 in 1 Charger Dock', price: 29.99, image: 'https://images.unsplash.com/photo-1605901309584-818e25960a8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100' }
        ],
        extras: ['Standard', 'Pro Pack (+$20)']
      },
      gallery: [
        'https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1600080972464-8e5f35f63d08?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1605901309584-818e25960a8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1551103782-8ab07afd45c1?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100'
      ],
      features: [
        {
          title: 'Pikachu-Themed Design',
          description: 'Vibrant yellow controllers with Pikachu details and custom LED lighting effects',
          icon: '⚡'
        },
        {
          title: 'Enhanced Precision',
          description: 'Advanced sensors for ultra-responsive gaming with minimal input lag',
          icon: '🎮'
        },
        {
          title: 'Extended Battery Life',
          description: 'Up to 40 hours of gameplay on a single charge with quick recharge capability',
          icon: '🔋'
        },
        {
          title: 'Multi-Platform Support',
          description: 'Compatible with Nintendo Switch, PC, and mobile devices',
          icon: '🌐'
        }
      ],
      specs: {
        design: [
          'Pikachu-themed vibrant yellow controllers',
          'Custom LED lighting with Pikachu-inspired effects',
          'Ergonomic design with textured grip',
          'Weight: 103g per controller (206g pair)'
        ],
        performance: [
          'Ultra-responsive buttons with 1ms input lag',
          'Enhanced HD Rumble for immersive feedback',
          'Accelerometer and gyroscope sensors',
          'Infrared Motion Camera'
        ],
        connectivity: [
          'Bluetooth 5.0 for stable wireless connection',
          'USB-C charging port',
          'Compatible with Nintendo Switch, PC, and mobile devices',
          'Near Field Communication (NFC) for amiibo functionality'
        ],
        battery: [
          '1000mAh lithium-ion battery',
          'Up to 40 hours of gameplay per charge',
          'Quick charge: 15 minutes for 3 hours of play',
          'Full charge time: 3.5 hours'
        ]
      }
    },
    'gaming-laptop': {
      name: 'CHILL GAMING 笔记本',
      description: '超便携14英寸游戏笔记本，搭载NVIDIA RTX 50系列显卡',
      basePrice: 9999,
      image: 'https://images.unsplash.com/photo-1603302576837-37561b2e2302?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080',
      options: {
        colors: ['black', 'mercury'],
        storage: ['1TB', '2TB'],
        memory: ['16GB', '32GB', '64GB'],
        processor: ['AMD Ryzen™ AI 9 365'],
        os: ['Windows 11 家庭版'],
        keyboard: ['美式布局', '中文布局']
      },
      gallery: [
        'https://images.unsplash.com/photo-1603302576837-37561b2e2302?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1593642634367-d91a135587b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1593642634315-48f5414c3ad9?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100'
      ]
    },
    'gaming-chair': {
      name: 'CHILL GAMING 电竞椅',
      description: '人体工学设计，全天候舒适支撑',
      basePrice: 1999,
      image: 'https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080',
      options: {
        colors: ['black', 'white', 'red'],
        material: ['PU皮革', '网布'],
        armrest: ['4D可调节', '固定式'],
        recline: ['90°-155°', '90°-180°']
      },
      gallery: [
        'https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1611079830811-dba1b918ca5a?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1563297007-0686b7003af7?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1586349906319-48d20e9d17e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100'
      ]
    },
    'mechanical-keyboard': {
      name: 'CHILL GAMING 机械键盘',
      description: '可定制按键，RGB背光，多种轴体选择',
      basePrice: 899,
      image: 'https://images.unsplash.com/photo-1625842268584-8f3296236761?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080',
      options: {
        colors: ['black', 'white'],
        switches: ['青轴', '红轴', '茶轴', '静音红轴'],
        layout: ['87键', '104键', '61键']
      },
      gallery: [
        'https://images.unsplash.com/photo-1625842268584-8f3296236761?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1618384887929-16ec33fab9ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1587829741301-dc798b83add3?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100',
        'https://images.unsplash.com/photo-1595225476474-57a67f26e4c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100'
      ]
    }
  };
  
  useEffect(() => {
    // 获取产品信息
    if (id) {
      // 检查是否直接匹配产品ID
      if (productDatabase[id]) {
        setProduct(productDatabase[id]);
        setCurrentImage(productDatabase[id].image);
      } else {
        // 尝试查找匹配的产品类别（例如：gaming-chair-pro 应该匹配到 gaming-chair）
        const baseProductId = Object.keys(productDatabase).find(key => 
          id.startsWith(key + '-') || id === key
        );
        
        if (baseProductId && productDatabase[baseProductId]) {
          // 如果找到基础产品，使用基础产品
          console.log(`未找到具体产品 ${id}，使用基础产品 ${baseProductId}`);
          setProduct(productDatabase[baseProductId]);
          setCurrentImage(productDatabase[baseProductId].image);
        } else if (productDatabase[id.split('-').slice(0, 2).join('-')]) {
          // 尝试匹配前两个词组合（例如：gaming-chair-pro-deluxe 应该匹配到 gaming-chair）
          const fallbackId = id.split('-').slice(0, 2).join('-');
          console.log(`未找到具体产品 ${id}，使用基础产品 ${fallbackId}`);
          setProduct(productDatabase[fallbackId]);
          setCurrentImage(productDatabase[fallbackId].image);
        } else {
          // 如果仍然找不到，默认使用笔记本
          console.log(`未找到产品 ${id}，使用默认产品 gaming-laptop`);
          setProduct(productDatabase['gaming-laptop']);
          setCurrentImage(productDatabase['gaming-laptop'].image);
        }
      }
    } else {
      // 如果没有提供ID，默认使用笔记本
      setProduct(productDatabase['gaming-laptop']);
      setCurrentImage(productDatabase['gaming-laptop'].image);
    }
  }, [id]);
  
  // 如果产品数据还未加载，显示加载状态
  if (!product) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-2xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      {/* 顶部公告栏 */}
      <div className="bg-gray-800 text-white text-center py-3 px-4">
        <p className="text-sm">
          Limited Time Offer: Get exclusive game bundles with your purchase!
          <Link to="/shop" className="ml-2 text-white underline hover:text-gray-300">
            Learn More &gt;
          </Link>
        </p>
      </div>
      
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl md:text-5xl font-bold mb-2">NEW VERSION | RGB Special Edition Custom Pikachu Nintendo Switch Joycon</h1>
        <div className="flex items-center mb-4">
          <span className="bg-green-600 text-white text-xs px-2 py-1 rounded mr-2">NEW</span>
          <p className="text-lg">{product.description}</p>
        </div>
        <div className="flex items-center mb-8">
          <span className="text-3xl font-bold text-white">${product.basePrice}</span>
          {id && id.includes('-pro') && (
            <div className="ml-4 flex items-center">
              <span className="text-xl text-gray-400 line-through mr-2">${Math.round(product.basePrice * 1.2)}</span>
              <span className="bg-red-600 text-white text-xs px-2 py-1 rounded">Save ${Math.round(product.basePrice * 0.2)}</span>
            </div>
          )}
        </div>
        
        <div className="flex flex-col lg:flex-row gap-8">
          {/* 左侧产品图片 */}
          <div className="lg:w-1/2">
            <div className="relative">
              <div className="bg-yellow-500 text-black font-bold px-4 py-2 inline-block mb-4">
                CHILL GAMING Exclusive
              </div>
              <div className="bg-gradient-to-r from-green-500/30 via-blue-500/30 to-red-500/30 p-8 rounded-lg">
                <img 
                  src={currentImage || product.image} 
                  alt={product.name} 
                  className="w-full h-auto"
                />
              </div>
              <div className="mt-4 flex gap-2">
                {product.gallery.map((img, index) => (
                  <button 
                    key={index} 
                    className={`border p-1 ${currentImage === img ? 'border-green-500' : 'border-gray-600'} hover:border-white`}
                    onClick={() => setCurrentImage(img.replace('w=100&h=100', 'w=1920&h=1080'))}
                  >
                    <img 
                      src={img} 
                      alt={`View ${index + 1}`} 
                      className="w-16 h-16 object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
          
          {/* 右侧定制选项 */}
          <div className="lg:w-1/2">
            {/* 动态渲染产品选项 */}
            {product.options && Object.entries(product.options).map(([optionType, values]) => {
              // 根据选项类型决定如何渲染
              const optionTitle = {
                colors: "Choose Color",
                addons: "Add On",
                extras: "Choose Package",
                storage: "Choose Storage",
                memory: "Choose Memory",
                processor: "Choose Processor",
                os: "Choose OS",
                keyboard: "Choose Keyboard Layout",
                switches: "Choose Switch Type",
                layout: "Choose Keyboard Layout",
                dpi: "Choose DPI",
                wireless: "Connection Type",
                material: "Choose Material",
                armrest: "Armrest Type",
                recline: "Recline Adjustment"
              }[optionType] || `Choose ${optionType}`;
              
              // 获取选项状态
              const getSelectedValue = () => {
                if (optionType === 'colors') return selectedColor;
                if (optionType === 'storage') return selectedStorage;
                if (optionType === 'memory') return selectedMemory;
                return values[0]; // 默认选择第一个
              };
              
              // 检查附加组件是否被选中
              const isAddonSelected = (addonId) => {
                return selectedAddons.includes(addonId);
              };
              
              // 设置选项状态
              const setSelectedValue = (value) => {
                if (optionType === 'colors') setSelectedColor(value);
                if (optionType === 'storage') setSelectedStorage(value);
                if (optionType === 'memory') setSelectedMemory(value);
              };
              
              // 切换附加组件选择状态
              const toggleAddon = (addonId) => {
                if (selectedAddons.includes(addonId)) {
                  setSelectedAddons(selectedAddons.filter(id => id !== addonId));
                } else {
                  setSelectedAddons([...selectedAddons, addonId]);
                }
              };
              
              // 价格增量
              const getPriceIncrement = (value) => {
                if (optionType === 'colors' && value === 'mercury') return 300;
                if (optionType === 'storage' && value === '2TB') return 600;
                if (optionType === 'memory' && value === '32GB') return 300;
                if (optionType === 'memory' && value === '64GB') return 600;
                if (optionType === 'extras' && value.includes('+$20')) return 20;
                return 0;
              };
              
              return (
                <div key={optionType} className="mb-8">
                  <div className="flex justify-between items-center">
                    <h2 className="text-xl font-bold">{optionTitle}</h2>
                  </div>
                  
                  {optionType === 'addons' ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      {values.map((addon) => (
                        <button 
                          key={addon.id}
                          className={`flex items-center border-2 ${isAddonSelected(addon.id) ? 'border-green-500' : 'border-gray-700'} rounded-md bg-black overflow-hidden h-24 relative`}
                          onClick={() => toggleAddon(addon.id)}
                        >
                          {/* 左侧图片 */}
                          <div className="w-24 h-full bg-gray-800 flex-shrink-0">
                            <img 
                              src={addon.image}
                              alt={addon.name}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          
                          {/* 右侧文字和价格 */}
                          <div className="flex-1 p-3 flex flex-col justify-between">
                            <div className="text-md font-medium text-white">{addon.name}</div>
                            <div className="text-sm text-gray-300 self-end">+${addon.price.toFixed(2)}</div>
                          </div>
                          
                          {/* 选中状态指示器 */}
                          {isAddonSelected(addon.id) && (
                            <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-r-[20px] border-t-transparent border-r-green-500"></div>
                          )}
                        </button>
                      ))}
                    </div>
                  ) : values.length > 1 ? (
                    <div className={`${optionType === 'colors' ? 'flex gap-3' : 'flex gap-4 flex-wrap'} mt-4`}>
                      {values.map((value) => (
                        optionType === 'colors' ? (
                          <div key={value} className="flex flex-col">
                            <button 
                              className={`w-[80px] h-[80px] border ${getSelectedValue() === value ? 'border-2 border-green-500' : 'border border-gray-600'} rounded-md bg-gray-800 flex items-center justify-center overflow-hidden relative`}
                              onClick={() => setSelectedValue(value)}
                            >
                              <div className="w-full h-full flex items-center justify-center">
                                {/* 颜色示例 */}
                                {value === 'pikachu-yellow' && (
                                  <img 
                                    src="https://images.unsplash.com/photo-1598550476439-6847785fcea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=80&h=80"
                                    alt="Pikachu Yellow"
                                    className="w-full h-full object-cover"
                                  />
                                )}
                                {value === 'pikachu-black' && (
                                  <img 
                                    src="https://images.unsplash.com/photo-1605901309584-818e25960a8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=80&h=80"
                                    alt="Pikachu Black"
                                    className="w-full h-full object-cover"
                                  />
                                )}
                                {value === 'black' && <div className="w-full h-full bg-gray-900"></div>}
                                {value === 'white' && <div className="w-full h-full bg-gray-100"></div>}
                                {value === 'red' && <div className="w-full h-full bg-red-600"></div>}
                                {value === 'mercury' && <div className="w-full h-full bg-gray-300"></div>}
                              </div>
                              {getSelectedValue() === value && (
                                <div className="absolute top-0 right-0 w-0 h-0 border-t-[20px] border-r-[20px] border-t-transparent border-r-green-500"></div>
                              )}
                            </button>
                            <div className="mt-2 text-center">
                              <div className="text-sm text-white font-medium">{value}</div>
                            </div>
                          </div>
                        ) : (
                          <button 
                            key={value}
                            className={`flex-1 min-w-[120px] h-20 border-2 ${getSelectedValue() === value ? 'border-green-500' : 'border-gray-700'} rounded-md bg-black flex items-center justify-center relative`}
                            onClick={() => setSelectedValue(value)}
                          >
                            <div>
                              <div>{value}</div>
                              {getPriceIncrement(value) > 0 && (
                                <div className="text-xs text-gray-400">+${getPriceIncrement(value)}</div>
                              )}
                            </div>
                          </button>
                        )
                      ))}
                    </div>
                  ) : (
                    <div className="mt-4 p-4 bg-gray-800/50 rounded-lg">
                      <div className="flex items-center">
                        <span className="text-gray-300">{values[0]}</span>
                        <span className="ml-2 bg-green-600/20 text-green-400 text-xs px-2 py-1 rounded">Default</span>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            
            {/* 添加到购物车按钮 */}
            <div className="mt-8">
              {(() => {
                // 计算总价
                let totalPrice = product.basePrice;
                
                // 添加附加组件价格
                if (product.options.addons) {
                  product.options.addons.forEach(addon => {
                    if (selectedAddons.includes(addon.id)) {
                      totalPrice += addon.price;
                    }
                  });
                }
                
                return (
                  <button className="w-full bg-green-600 hover:bg-green-700 text-white py-4 rounded-lg text-xl font-bold">
                    Add to Cart - ${totalPrice.toFixed(2)}
                  </button>
                );
              })()}
              <p className="text-center text-sm text-gray-400 mt-2">Available Shipping</p>
            </div>
          </div>
        </div>
        
        {/* 产品特性和规格 - 放在图片下方 */}
        <div className="mt-12">
          {/* 产品特性 */}
          {product.features && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold mb-6 border-b border-gray-700 pb-2">Key Features</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {product.features.map((feature, index) => (
                  <div key={index} className="bg-gray-800/50 p-6 rounded-lg">
                    <div className="flex items-center space-x-3 mb-3">
                      <div className="text-3xl text-primary-400">{feature.icon}</div>
                      <h3 className="text-xl font-semibold text-white">{feature.title}</h3>
                    </div>
                    <p className="text-gray-300">{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* 技术规格 */}
          {product.specs && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold mb-6 border-b border-gray-700 pb-2">Technical Specifications</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {Object.entries(product.specs).map(([category, items]) => (
                  <div key={category} className="bg-gray-800/50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-white capitalize mb-4">{category}</h3>
                    <ul className="space-y-3">
                      {items.map((item, idx) => (
                        <li key={idx} className="flex items-start text-gray-300">
                          <span className="text-primary-400 mr-2">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCustomize;